import { benefitsTextSchema } from '@ecomm/city-state-data/cityStateSchema'
import { CITY_STATE_TEMPLATE_REGION_CONTENT_QUERY } from '@ecomm/city-state-data/city_state_template_query'
import { useContentful } from '@ecomm/shared-apollo'
import { useMemo } from 'react'

export const useBenefitsTextQuery = (region: string) => {
  const { data: rawApolloData } = useContentful(
    CITY_STATE_TEMPLATE_REGION_CONTENT_QUERY,
    {
      regionContentId: region
    }
  )

  return useMemo(
    () => benefitsTextSchema.parse(rawApolloData?.['text']),
    [rawApolloData]
  )
}
